// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3IlJs","footer":"ModalFilter_footer__1XilF"};